import { EanProductPickerComponent } from './ean-product-picker.component';

export const EanProductPickerModule = angular
  .module('sfMobile.components.ean-product-picker', [
    'sfMobile.components.button-header-close',
  ])
  .component('sfEanProductPicker', EanProductPickerComponent).name;
